import PropTypes from "prop-types";
import { toast } from "react-hot-toast";
import {
  AccessTimeOutlined as ClockIcon,
  CheckCircleOutlined as CheckCircleIcon,
} from "@mui/icons-material"; // Importing Material-UI Icons

import { Button } from "@mui/material"; // Importing Material-UI Button
import "./EmployeeStatus.scss";
import supabase from "../../../api/supabase"; // Import Supabase client

const EmployeeStatus = ({ taskRecord, activeCell, setTaskRecord }) => {
  const updateStatus = async (newStatus) => {
    if (!activeCell) {
      toast.error("Please select a task first");
      return;
    }

    const updatedRecords = taskRecord.map((record, index) => {
      if (index === activeCell.recordIndex) {
        return {
          ...record,
          status: newStatus,
        };
      }
      return record;
    });

    setTaskRecord(updatedRecords); // Updating the taskRecord state

    // TODO: Update the status in Supabase
    const { error } = await supabase
      .from("taskManager")
      .update({ status: newStatus })
      .eq("id", taskRecord[activeCell.recordIndex].id);

    if (error) {
      toast.error("Failed to update status in the database.");
    } else {
      toast.success("Status updated successfully!");
    }
  };

  return (
    <div className="employee-status-container">
      <Button
        //variant="outlined"
        startIcon={<ClockIcon />}
        onClick={() => updateStatus("working")}
        sx={{
          borderRadius: "50px", // Round border
          borderColor: "#32CD32", // Custom border color (Lime Green)
          color: "#388e3c", // Custom text color
          backgroundColor: "#c8e6c9", // Light green background
          height: "30px",
          padding: "0px 12px", // Add padding to the button
          "&:hover": {
            borderColor: "#32CD32", // Same color on hover
            backgroundColor: "#a5d6a7", // Slightly darker background on hover
          },
        }}
      >
        WORKING
      </Button>
      <Button
        //variant="outlined"
        startIcon={<ClockIcon />}
        onClick={() => updateStatus("break")}
        sx={{
          borderRadius: "50px", // Round border
          borderColor: "#FFA500", // Custom border color (Orange)
          color: "#f57c00", // Custom text color
          backgroundColor: "#ffe0b2", // Light orange background
          height: "30px",
          padding: "0px 12px", // Add padding to the button
          "&:hover": {
            borderColor: "#FFA500", // Same color on hover
            backgroundColor: "#ffcc80", // Slightly darker background on hover
          },
        }}
      >
        BREAK
      </Button>

      <Button
        //variant="outlined"
        startIcon={<CheckCircleIcon />}
        onClick={() => updateStatus("")}
        sx={{
          borderRadius: "50px", // Round border
          borderColor: "#1E90FF", // Custom border color (Dodger Blue)
          color: "#03a9f4", // Custom text color
          backgroundColor: "#b3e5fc", // Light blue background
          height: "30px",
          padding: "0px 12px", // Add padding to the button
          "&:hover": {
            borderColor: "#1E90FF", // Same color on hover
            backgroundColor: "#81d4fa", // Slightly darker background on hover
          },
        }}
      >
        DONE
      </Button>
    </div>
  );
};

EmployeeStatus.propTypes = {
  taskRecord: PropTypes.array.isRequired,
  activeCell: PropTypes.object,
  setTaskRecord: PropTypes.func,
};

export default EmployeeStatus;
